<template>
    <div v-if="open">
        <Window :id="'relevancePart'" :title="title" ref="Window">
            <div slot="headButton" class="fR cb tra-fast_E ml05x_E">
                <button class="bdSub boxR hover-bg-highLight" @click="Close">{{$t('cmd85',['取消'])}}</button>
                <button @click="save" type="button" class="functionBtn">{{$t('cmd84',['保存'])}}</button>
            </div>
            <div fillHeight="window,-#relevancePart .head,-space,-space" scroll>
              <div class="w60pct mc mt4x posR">
                  <div class="fs14x pb2x" v-show="type=='single' && RoleIds.length">{{getLanguageStr('phrase733','该电站管理者不是本商家，所以只拥有授权给公司内部成员的授权功能')}}</div>
                  <div class="fs14x pb2x" v-show="type!='single' && RoleIds.length==allStationIds.length">{{getLanguageStr('phrase738','所选电站中所有电站创建者不是本商家，所以只拥有批量授权内部成员的授权功能')}}</div>
                  <div class="fs14x pb2x" v-show="type!='single' && RoleIds.length!= allStationIds.length && RoleIds.length!=0">{{getLanguageStr('phrase720','所选电站中部分电站管理者不是本商家，所以批量授权商家将只应用于本商家创建的电站')}}</div>
                  <div v-permissions="'A/B/A14'" permission-type="none">
                      <TagForm :title="this.type !=='single'?getLanguageStr('cmd149','批量')+getLanguageStr('word1930','授权内部成员'):getLanguageStr('word1930','授权内部成员')" :showDetail="Boolean(false)" :titleDesc="text.personal" :ctrlBtn="false">
                          <related-person class="afterNew w80pct mt2x" @Update="updatePersonList" ref="AddPerson" title=""></related-person>
                      </TagForm>
                  </div>
                 <div v-if="powerType=='light'&&!RoleIds.length && this.type =='single'" v-permissions="'A/B/A17'" permission-type="none">
                      <TagForm :title="getLanguageStr('word1716','授权用户')" :showDetail="Boolean(false)" :titleDesc="$t('phrase734',['将电站授权给用户，这样用户可以看到这个电站。非必填项，你可以在电站详情中再次操作。'])" :ctrlBtn="false">
                          <div class="mb1x">{{getLanguageStr('word1546','用户')}}</div>
                          <RelevanceAccount ref="relevanceAccount" :stationId="stationIds" @UpdateData="data=>usersList=data"></RelevanceAccount>
                      </TagForm>
                  </div>
                  <div v-if="powerType=='light'" v-show="isShowBusiness" v-permissions="'A/B/A19'" permission-type="none">
                      <TagForm :title="this.type !=='single'?getLanguageStr('cmd261','批量授权商家'):getLanguageStr('word297','授权商家')" :showDetail="Boolean(false)" :titleDesc="text.business" :ctrlBtn="false">
                          <div class="mb1x">{{getLanguageStr('word1650','商家')}}</div>
                          <RelevanceBusiness ref="RelevanceBusiness" :stationId="stationIds" @UpdateData="data=>businessList = data"></RelevanceBusiness>
                      </TagForm>
                  </div>
              </div>
            </div>
        </Window>
    </div>
</template>
<script>
import * as lib from '@/util/lib.js'
import {getLanguageStr} from '@/util/language.js'
import Window from '@/components/common/ui/WindowForNew.vue'
import TagForm from '@/components/common/ui/TagForm.vue'
import RelatedPerson from '@/view/maintain/light/plant/part/RelatedPerson'
import RelevanceAccount from '@/view/maintain/light/plant/relevance/RelevanceUser'
import RelevanceBusiness from '@/view/maintain/light/plant/relevance/RelevanceBusiness'
import {AddRelatedBus, AddRelatedUser} from '@/api/maintain/plant/relative.js'
import {apiAddPerson} from '@/api/maintain/plant/list.js'

export default {
  name: 'relevancePart',
  components: {Window, TagForm, RelatedPerson, RelevanceAccount, RelevanceBusiness},
  props: {
    powerType:{//能源类型light,wind
      type:String,
      default:"light"
    }
  },
  data () {
    return {
      open: false,
      title: '',
      allStationIds: [],
      stationIds: [],
      RoleIds: [],
      type: 'single',
      businessList: [],
      usersList: [],
      PersonList: [],
      text:{
        personal:'',
        business:'',
      }

    }
  },
  computed: {
    isShowBusiness () {
      if (this.type === 'single' && this.RoleIds.length > 0) {
        return false
      } else if (this.type === 'single' && this.RoleIds.length === 0) {
        return true
      } else if (this.type !== 'single' && this.allStationIds.length == this.RoleIds.length) {
        return false
      } else if (this.type !== 'single' && this.allStationIds.length !== this.RoleIds.length) {
        return true
      }
    }
  },
  methods: {
    getLanguageStr,
    show (data, type, entityRelIds) {
      this.open = true
       	this.$nextTick(() => {
        this.$refs.Window.show()
        this.type = type
        if (type == 'single') {
          this.title = getLanguageStr('cmd59', '授权')
          this.text={
            personal:getLanguageStr('plant370', '将电站授权给商家内部成员，你的同事也能看到这个电站。非必填项，你可以在电站详情中再次操作。'),
            business:getLanguageStr('phrase735', '将电站授权给其他商家，这样其他商家也能看到这个电站。非必填项，你可以在电站详情中再次操作。')
          }
          if (entityRelIds && entityRelIds.length) {
            this.allStationIds = data
            this.stationIds = data
            entityRelIds[0] ? this.RoleIds = entityRelIds : this.RoleIds = []
          } else {
            this.allStationIds = [data[0].id]
            this.stationIds = [data[0].id]
            this.RoleIds = data[0].entityRel.id ? [data[0].entityRel.id] : []
          }
        } else {
          this.title = getLanguageStr('manage364', '批量授权')
          this.text={
            personal:getLanguageStr('phrase731', '将电站批量授权给商家内部成员，你的同事也能看到这些电站。'),
            business:getLanguageStr('phrase732', '将电站批量授权给其他商家，这样其他商家也能看到这些电站。')
          }
          this.allStationIds = data.map(el => el.id)
          let entityRelList = data.filter(el => el.entityRel.id)
          this.stationIds = data.filter(el => !el.entityRel.id).map(el => el.id)
          this.RoleIds = entityRelList.map(el => el.entityRel.id)
        }
        lib.setScroll($(this.$el).find('[scroll]'))
        lib.fillHeight()
      })
    },
    reset () {
      this.businessList = []
      this.usersList = []
      this.PersonList = []
      this.type = 'single'
    },
    Close () {
      this.$refs.Window.hide()
      setTimeout(() => {
        this.open = false
      }, 500)
    },
    // 关联人返回
    updatePersonList (list) {
      this.PersonList = list
    },
    test () {
      this.$refs.test.show()
    },
    save () {
      let allPromiseList = []
      if (!this.businessList.length && !this.usersList.length && !this.PersonList.length) {
        this.Close()
      } else {
        if (this.businessList.length) {
          allPromiseList.push(this.relBus())
        }
        if (this.usersList.length) {
          allPromiseList.push(this.relUser())
        }
        if (this.PersonList.length) {
          allPromiseList.push(this.relPerson())
        }
        Promise.all(allPromiseList).then(res => {
          this.$emit('Update')
          this.Close()
        }, error => {
          !_.isEmpty(error) && this.$notify(error)
        })
      }
    },
    // 关联商家
    relBus () {
      let entityRelIdList = this.businessList.map(el => el.entityRelId)
      let request = {
        entityRelIdList,
        stationIdList: this.stationIds
      }
      return new Promise((resolve, reject) => {
        AddRelatedBus(request).then(res => {
          resolve(res)
        }, error => {
          reject(error)
        })
      })
    },
    // 关联用户
    relUser () {
      let entityRelIdList = this.usersList.map(el => el.entityRelId)
      let request = {
        entityRelIdList,
        stationIdList: this.stationIds
      }
      return new Promise((resolve, reject) => {
        AddRelatedUser(request).then(res => {
          resolve(res)
        }, error => {
          reject(error)
        })
      })
    },
    // 关联内部成员
    relPerson () {
      // let stationIds=[]
      // if(this.type !=='single' && !this.stationIds.length){
      //   stationIds=this.allStationIds
      // }else{
      //   stationIds=this.stationIds
      // }
      let request = {
        stationIds:  this.allStationIds,
        watcherIds: this.PersonList
      }
      return new Promise((resolve, reject) => {
        apiAddPerson(request).then(res => {
          resolve(res)
        }, error => {
          reject(error)
        })
      })
    }
  },
  mounted () {
    lib.setScroll($(this.$el).find('[scroll]'))
    lib.fillHeight()
  }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/view/maintain/part/RelevancePart.vue